import { render, staticRenderFns } from "./PgaCertificationsSelectUsers.vue?vue&type=template&id=037ff50b&"
import script from "./PgaCertificationsSelectUsers.vue?vue&type=script&lang=ts&"
export * from "./PgaCertificationsSelectUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('037ff50b')) {
      api.createRecord('037ff50b', component.options)
    } else {
      api.reload('037ff50b', component.options)
    }
    module.hot.accept("./PgaCertificationsSelectUsers.vue?vue&type=template&id=037ff50b&", function () {
      api.rerender('037ff50b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Resource/Certifications/Components/PgaCertificationsSelectUsers.vue"
export default component.exports